import { render, staticRenderFns } from "./BatchOperationManagerSection.vue?vue&type=template&id=4c195150&"
import script from "./BatchOperationManagerSection.vue?vue&type=script&lang=ts&"
export * from "./BatchOperationManagerSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports